import fetch from 'utils/fetch';
import { useState, useEffect } from 'react';
import { Deferred } from './deffered';

const cache: Map<string, Promise<any>> = new Map();

type FetchParameters = Parameters<typeof fetch>;
/**
 * React hook for async fetch loading witch caching.
 *
 * The parameters are the same as for standard fetch.
 *
 * @param parameters
 */
export function useCachedFetch<TResult>(...parameters: FetchParameters) {
  const [result, setResult] = useState<TResult>();

  const key = JSON.stringify(parameters);

  useEffect(() => {
    async function load() {
      const promise: Promise<TResult> | undefined = cache.get(key);
      if (promise !== undefined) {
        const r = await promise;
        setResult(r);
      } else {
        const deffered = new Deferred<TResult>();
        cache.set(key, deffered.promise);

        addDefaultContentType(parameters);

        const response = await fetch(...parameters);
        const data = await response.json();
        deffered.resolve(data);
        setResult(data);
      }
    }

    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return result;
}

function addDefaultContentType(parameters: FetchParameters) {
  if (parameters[1] === undefined) {
    parameters[1] = {};
  }

  if (parameters[1].headers === undefined) {
    parameters[1].headers = new Headers();
  }

  if (!parameters[1].headers.has('Content-Type')) {
    parameters[1].headers.set('Content-Type', 'application/json');
  }
}
